export interface SetStockAlertRequest {
  productID: number;
  optionValueID?: string;
}

export const setStockAlertRequestOutputTransformer = (
  req: SetStockAlertRequest,
) => ({
  product_id: req.productID,
  options: req.optionValueID ? [{ value_id: req.optionValueID }] : undefined,
});
